"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trash = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Trash = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .ory-controls-trash {\n        position: fixed;\n        bottom: -64px;\n        z-index: 500;\n        left: calc(50% - 200px);\n        transition: bottom 200ms ease;\n\n        button {\n            -webkit-appearance: none;\n            -webkit-backface-visibility: hidden;\n            text-align: center;\n            height: 60px;\n            width: 60px;\n            color: #ffffff;\n            font-size: 24px;\n            border-radius: 50%;\n            background-color: ", ";\n            box-shadow: 0 0 5px 1px ", ";\n            border: none;\n            transition: all 200ms ease;\n            -webkit-transform: translateZ(0);\n            transform: scale(1) translateZ(0);\n\n            &:disabled {\n                transform: scale(0.8);\n                box-shadow: 0 0 3px 1px ", ";\n            }\n        }\n    }\n\n    .ory-controls-trash.ory-controls-trash-active {\n        bottom: 16px;\n    }\n"])), function (props) {
  return props.theme.admin.colors.danger;
}, function (props) {
  return props.theme.admin.colors.danger;
}, function (props) {
  return props.theme.admin.colors.danger;
});

exports.Trash = Trash;